import { jsx as _jsx } from "react/jsx-runtime";
import Notice, { TYPES } from './Notice';
const Error = () => {
    return (_jsx(Notice, { type: TYPES.ERROR, title: 'Fout opgetreden', children: "Wij zijn op de hoogte gebracht van de fout. Probeer het later opnieuw." }));
};
export default Error;
